import React, { Fragment, useEffect } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import StakeholdersView from './StakeholdersView';

const Stakeholders = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <Fragment>
      <Helmet>
        <title>Stakeholders</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <StakeholdersView />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </Fragment>
  );
};

export default Stakeholders;
